import React from 'react'
import './ThankYou.css'
import bison_logo from '../Assets/bison_logo.png'
import logo from '../Assets/logo.png'
import { Link } from 'react-router-dom'

const ThankYou = () => {
  return (
    <div className='thank-you text-white'>
      <div className="greeting items-center justify-center w-full max-w-[550px]">
        <img src={logo} alt="logo" className='w-56 mx-auto' />
        <h1>Thank You</h1>

        <h2>For The Order!</h2>
        <p>We sent you an email of the receipt.</p>

        <Link to='https://whatsapp.com/channel/0029VajLAIC3gvWZqagiEL2L'><button>For Further Updates</button></Link>
        <Link to='/'><button>Go to Home Page</button></Link>
      </div>
      <p className='text-[#4C1B1C] text-sm'>Designed & Developed by BISON CORPS.</p>
      <p className='text-[#4C1B1C] text-sm'>© All rights reserved.</p>
    </div>
  )
}

export default ThankYou
